var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRfiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#5CB335",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.937 11H16.625C14.6313 11 13 12.575 13 14.5V42.5C13 44.425 14.6131 46 16.6069 46H38.375C40.3687 46 42 44.425 42 42.5L41.87 19.8748L32.937 11ZM38.375 42.5H16.625V14.5H31.3834V20.9998H38.375V42.5Z",
    fill: "#3F7B25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H22.0776C22.4837 24 22.8366 24.0687 23.1363 24.206C23.4361 24.3434 23.6669 24.5467 23.8289 24.8159C23.9932 25.0852 24.0754 25.4176 24.0754 25.8132C24.0754 26.1566 24.0283 26.4437 23.934 26.6745C23.8397 26.9052 23.708 27.0962 23.5388 27.2473C23.372 27.3956 23.1774 27.5179 22.955 27.614L22.5381 27.8819H20.7941L20.7868 26.7651H22.0776C22.2395 26.7651 22.3737 26.7321 22.4801 26.6662C22.5864 26.6003 22.6662 26.5069 22.7194 26.386C22.775 26.2624 22.8028 26.1154 22.8028 25.9451C22.8028 25.772 22.775 25.6236 22.7194 25.5C22.6638 25.3764 22.5816 25.2816 22.4728 25.2157C22.3664 25.1497 22.2347 25.1168 22.0776 25.1168H21.2727V30H20V24ZM22.8898 30L21.7223 27.3462L23.0711 27.3379L24.2531 29.9382V30H22.8898Z",
    fill: "#3F7B25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.488 24V30H25.2154V24H26.488ZM28.5402 26.4973V27.6099H26.1255V26.4973H28.5402ZM28.7469 24V25.1168H26.1255V24H28.7469Z",
    fill: "#3F7B25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24V30H29.731V24H31Z",
    fill: "#3F7B25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 32H20V35H29V32Z",
    fill: "#3F7B25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36H20V39H35V36Z",
    fill: "#3F7B25"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfiIcon);
export default __webpack_public_path__ + "static/media/rfi-icon.73611d22e06e2b8dda005b8d6f6fc3ba.svg";
export { ForwardRef as ReactComponent };